import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  privacy_policy,
  terms_conditions,
} from "../../settings/footers/Footer.utils";
import { logoTitle } from "../../settings/headers/Header.utils";

export default () => {
  return (
    <footer
      className="bg-dark text-white mt-5 p-4"
      style={{ left: 0, bottom: 0, width: "100%" }}
    >
      <Container>
        <Row>
          <Col>
            {" "}
            <Link className="nav-link" to="/feed">
              Go To Rooms Feed
            </Link>
          </Col>

          <Col>
            {" "}
            Copyright &copy;{" "}
            <a href="https://marius-monkam.herokuapp.com/">
              Marius Monkam
            </a>{" "}
            {new Date().getFullYear()} {logoTitle}
          </Col>
          <Col>
            {" "}
            <p className="text-right">
              <small>
                <a href={privacy_policy}>Privacy Policy</a> |{" "}
                <a href={terms_conditions}>Terms & Conditions </a>{" "}
              </small>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
